export default class DonorAtWork {
  // @ts-ignore
  public id: string;
  // @ts-ignore
  public externalId: string;
  public patientId: string;
  public timeout: string;
  public startStatus: Date;
  public status: number | null;
  public actionId: string;
  public laboratoryId: string;
  public comment: string;
  public operatorId: string;
  public operatorEmail: string;
  public operatorPhone: string;
  public operatorAdphone: string;
  public operatorName: string;
  public rejreasonId: string;
  public rejectionDate: Date;
  public rejectionComment: string;
  public hlaDate: Date | null;
  public ctOrderDate: Date | null;
  public ctSendDate: string | null;
  public idmSendDate: Date | null;
  public ctRecieveDate: string | null;

  // @ts-ignore
  public diagnosis: string;
  // @ts-ignore
  public statuses: [];
  // @ts-ignore
  public rejectionReasons: [];
  // @ts-ignore
  public operators: [];
  // @ts-ignore
  public operatorsData: [];
  // @ts-ignore
  public isReserved: boolean;

  // @ts-ignore
  public services: [];
  // @ts-ignore
  public donorServices: [];
  // @ts-ignore
  public donorBills: [];
  // @ts-ignore
  public service: string;

  public isTransplantationAccept: string;
  // @ts-ignore
  public collectionCenterId: string;
  // @ts-ignore
  public collectionCenterName: string;
  // @ts-ignore
  public transfusiologistId: string;
  // @ts-ignore
  public transfusiologistName: string;
  // @ts-ignore
  public transfusiologistEmail: string;
  // @ts-ignore
  public transfusiologistPhone: string;
  // @ts-ignore
  public transfusiologistAdphone: string;
  // @ts-ignore
  public medicalExamination: Date;
  // @ts-ignore
  public idmConfirm: string;
  // @ts-ignore
  public collectionDate: Date | null;
  // @ts-ignore
  public collectionMethodId: string | null;
  // @ts-ignore
  public collectionMethods: [];
  // @ts-ignore
  public paidTypes: [];
  public ctFileInfo: any;
  public getCellsFactDate: Date;
  public getCellsFactMethod: string;
  public cellularity: string;
  public isFrozen: boolean;
  // @ts-ignore
  public paidType: number | null;
  // @ts-ignore
  public transfusiologists: [];
  // @ts-ignore
  public infectionsResult: any;

  public requestDate: any;

  constructor() {
    this.patientId = '';
    this.timeout = '';
    this.startStatus = new Date();
    this.status = null;
    this.actionId = '';
    this.laboratoryId = '';
    this.comment = '';
    this.operatorId = '';
    this.operatorEmail = '';
    this.operatorPhone = '';
    this.operatorAdphone = '';
    this.operatorName = '';
    this.rejreasonId = 'init';
    this.rejectionDate = new Date();
    this.rejectionComment = '';
    this.hlaDate = new Date();
    this.ctOrderDate = new Date();
    this.ctSendDate = 'init';
    this.idmSendDate = new Date();
    this.ctRecieveDate = 'init';
    this.ctFileInfo = null;
    this.isTransplantationAccept = 'false';
    this.getCellsFactDate = new Date();
    this.getCellsFactMethod = '';
    this.cellularity = '';
    this.isFrozen = false;
    this.requestDate = null;
  }
}
